import PromotionsApi from '@/services/shop/PromotionsApi'
import type {
  DiscountType,
  PromotionGroupCreatePayload,
  PromotionGroupInterface,
  PromotionGroupUpdatePayload,
  PromotionGroupVariantInterface,
  PromotionInterface,
  PromotionUpsertPayload,
} from './Promotion.types'

export {
  PromotionGroupCreatePayload,
  PromotionGroupInterface,
  PromotionGroupUpdatePayload,
  PromotionGroupVariantInterface,
  PromotionInterface,
  PromotionUpsertPayload,
}

export class PromotionGroupVariantDTO
  implements PromotionGroupVariantInterface
{
  id = ''
  arena_promotion_group_id = ''
  arena_variant_id = ''
  created_at = ''
  updated_at = ''
}

export class PromotionGroupDTO implements PromotionGroupInterface {
  id = ''
  arena_promotion_id = ''
  name = ''
  category_id = ''
  quantity = 0
  variants: PromotionGroupVariantInterface[] = []
  created_at = ''
  updated_at = ''
}

export class PromotionDTO implements PromotionInterface {
  id = ''
  arena_id = 0
  name = ''
  image = ''
  description = ''
  discount_value = ''
  discount_type: DiscountType = 'percentage'
  sort_order = 0
  active = false
  groups: PromotionGroupInterface[] = []
  created_at = ''
  updated_at = ''
}

export default class Promotion extends PromotionDTO {
  static api = PromotionsApi

  constructor(DTO: PromotionDTO) {
    super()
    Object.assign(this, DTO)
  }
}
